import { fontDisplay, hexToRgbA, lineHeightToFontSize } from 'common-react';
import { createStyles, makeStyles, Theme } from 'ui-components';

const PROMO_DESCRIPTION_WIDTH = 509;
const INVESTMENT_INPUT_WIDTH = 343;

export default makeStyles((theme: Theme) => createStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    minWidth: 0,
  },

  promoDescription: {
    maxWidth: PROMO_DESCRIPTION_WIDTH,
  },

  resultCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    boxShadow: `inset 0 0 0 1px ${theme.color.greys[15]}`,
    padding: 40,

    [theme.breakpoints.down('sm')]: {
      padding: 24,
    },

    [theme.breakpoints.down('xs')]: {
      padding: 16,
    },
  },

  ike: {
    '& $accentText': {
      color: theme.color.charts.chartColor7,
    },

    '& $investmentSlider .MuiSlider-track': {
      backgroundColor: theme.color.charts.chartColor7,
    },
  },

  ikze: {
    '& $accentText': {
      color: theme.color.charts.chartColor10,
    },

    '& $investmentSlider .MuiSlider-track': {
      backgroundColor: theme.color.charts.chartColor10,
    },
  },

  accentText: {
    color: 'inherit',
  },

  resultRow: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 16,
  },

  resultLabelGroup: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
  },

  resultValue: {
    flexShrink: 0,
    textAlign: 'right',
    whiteSpace: 'nowrap',
  },

  totalValue: {
    flexShrink: 0,
    textAlign: 'right',
    whiteSpace: 'nowrap',

    [theme.breakpoints.down('xs')]: {
      fontSize: theme.fontSize.xxl,
      lineHeight: lineHeightToFontSize.xxl,
    },
  },

  taxNote: {
    marginTop: 8,
    padding: 16,
    borderRadius: 8,
    backgroundColor: hexToRgbA(theme.color.greens[10], 0.5),
  },

  taxNoteAccent: {
    font: 'inherit',
    fontWeight: 700,
    color: theme.color.greens[100],
  },

  investment: {
    display: 'flex',
    flexDirection: 'column',
    gap: 32,
    paddingTop: 8,
  },

  investmentInput: {
    width: '100%',
    maxWidth: INVESTMENT_INPUT_WIDTH,

    '& .MuiFormControl-root, & .MuiInputBase-root': {
      width: '100%',
    },
  },

  investmentSlider: {
    width: '100%',
  },

  assumptions: {
    marginTop: 24,
  },

  assumptionsSummary: {
    flexDirection: 'row-reverse',
    justifyContent: 'flex-end',
    gap: 12,

    '& .MuiAccordionSummary-expandIcon': {
      marginLeft: 0,
      transform: 'rotate(-90deg)',

      '&.Mui-expanded': {
        transform: 'rotate(0deg)',
      },
    },
  },

  assumptionsIcon: {
    width: 8,
    height: 6,

    '& path': {
      fill: theme.color.greys[80],
    },
  },

  assumptionsTitle: {
    font: fontDisplay('normal', theme.fontSize.base, lineHeightToFontSize.base),
  },

  assumptionsDetails: {
    padding: 0,
  },

  assumptionsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    margin: 0,
    padding: 0,
    listStyle: 'none',
  },

  assumptionsItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 8,
    paddingLeft: 2,

    '&:before': {
      content: '"\\2022"',
      flexShrink: 0,
      font: fontDisplay('normal', theme.fontSize.base, lineHeightToFontSize.base),
      color: theme.color.oranges[50],
    },
  },

  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 40,
    flexWrap: 'wrap',
    paddingTop: 24,

    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column-reverse',
      gap: 16,
    },
  },

  learnMoreButton: {
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
}), { name: 'RetirementCalculatorOutcome' });
